// extracted by mini-css-extract-plugin
module.exports = {"introduce_more":"introduce-more_introduce_more__2z0yI"};